export const getFileNameByUrl = (url) => {
    const pos = url.lastIndexOf('/');
    const str = url.substring(pos + 1); // 名字.文件格式？参数
    const pramIndex = str.lastIndexOf('?');
    const fileName = pramIndex > -1 ? str.substring(0, pramIndex) : str;
    console.log('str', str, 'fileName', fileName);
    return decodeURI(fileName);
};
export const exportFile = (url) => {
    const a = document.createElement('a');
    const fileName = getFileNameByUrl(url);
    a.style.display = 'none';
    a.download = fileName; // 文件名
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
